const services = [
  {
    title: 'Airport Transfers',
    image: '/assets/images/abt-s1.png',
    icon: '/assets/images/abt-s-icons1.png',
    description:
      'Reliable airport pickups and drop-offs, available 24/7.',
  },
  {
    title: 'Private Day Trips',
    image: '/assets/images/abt-s2.png',
    icon: '/assets/images/abt-s-icons5.png',
    description:
      'Explore beautiful destinations at your own pace.',
  },
  {
    title: 'Ski Transfers',
    image: '/assets/images/abt-s3.png',
    icon: '/assets/images/abt-s-icons4.png',
    description:
      "Comfortable transfers to Austria's top ski resorts.",
  },
  {
    title: 'Business Travel',
    image: '/assets/images/abt-s4.png',
    icon: '/assets/images/abt-s-icons3.png',
    description:
      'Travel efficiently for work, meetings, and events.',
  },
  {
    title: 'Private Europe Tours',
    image: '/assets/images/abt-s5.png',
    icon: '/assets/images/abt-s-icons2.png',
    description:
      'We make travel easy across Austria and Europe.',
  },
] as const

export default function AbtService() {
  return (
    <section className="w-full bg-white px-4 py-[70px] sm:px-6 lg:px-8 lg:py-[90px]">
      <div className="mx-auto w-full max-w-[1320px]">

        {/* =====================================================
            SECTION HEADING
        ===================================================== */}
        <div className="flex flex-col items-center text-center">
          <div
            className="
              inline-flex
              h-[25px]
              items-center
              justify-center
              rounded-[9px]
              border
              border-[#D3D3D3]
              bg-[#F2F2F2]
              px-[14px]
              shadow-[0_1px_3px_rgba(0,0,0,0.04)]
            "
          >
            <span className="font-host text-[10px] font-medium text-[#FF6425]">
              What We Do
            </span>
          </div>

          <h2
            className="
              mt-[14px]
              font-host
              text-[25px]
              font-semibold
              leading-[1.15]
              tracking-[-0.03em]
              text-[#111111]

              sm:text-[29px]
              lg:text-[31px]
            "
          >
            Services Designed Around You
          </h2>
        </div>

        {/* =====================================================
            DESKTOP / TABLET
        ===================================================== */}
        <div className="relative mt-[48px] hidden md:block">

          {/* ===================================================
              DOTTED ARCS
          =================================================== */}
          <div
            className="
              pointer-events-none
              absolute
              left-0
              right-0
              top-0
              z-20
              h-[135px]
            "
          >
            <svg
              viewBox="0 0 1000 135"
              preserveAspectRatio="none"
              className="h-full w-full"
              aria-hidden="true"
            >
              {/* Arc 1 */}
              <path
                d="M90 112 C135 10 225 10 295 112"
                fill="none"
                stroke="#777777"
                strokeWidth="1.25"
                strokeDasharray="7 8"
                strokeLinecap="round"
              />

              {/* Arc 2 */}
              <path
                d="M295 112 C350 10 430 10 500 112"
                fill="none"
                stroke="#777777"
                strokeWidth="1.25"
                strokeDasharray="7 8"
                strokeLinecap="round"
              />

              {/* Arc 3 */}
              <path
                d="M500 112 C555 10 640 10 705 112"
                fill="none"
                stroke="#777777"
                strokeWidth="1.25"
                strokeDasharray="7 8"
                strokeLinecap="round"
              />

              {/* Arc 4 */}
              <path
                d="M705 112 C760 10 845 10 910 112"
                fill="none"
                stroke="#777777"
                strokeWidth="1.25"
                strokeDasharray="7 8"
                strokeLinecap="round"
              />

              {/* Red dots */}
              {[90, 295, 500, 705, 910].map((x) => (
                <circle
                  key={x}
                  cx={x}
                  cy="112"
                  r="8"
                  fill="#B50E11"
                />
              ))}
            </svg>
          </div>

          {/* ===================================================
              CARDS
          =================================================== */}
          <div
            className="
              grid
              grid-cols-5
              gap-[22px]
              pt-[111px]
            "
          >
            {services.map((service) => (
              <article
                key={service.title}
                className="
                  flex
                  h-[285px]
                  min-w-0
                  flex-col
                  overflow-hidden
                  rounded-[12px]
                  bg-[#E1E1E1]
                  px-[12px]
                  pb-[14px]
                  pt-[13px]
                "
              >
                {/* Title */}
                <div className="flex min-h-[21px] items-center gap-[4px]">
                  <img
                    src={service.icon}
                    alt=""
                    aria-hidden="true"
                    className="
                      h-[14px]
                      w-[14px]
                      shrink-0
                      object-contain
                    "
                  />

                  <h3
                    className="
                      whitespace-nowrap
                      font-host
                      text-[13px]
                      font-medium
                      leading-none
                      text-[#262626]
                    "
                  >
                    {service.title}
                  </h3>
                </div>

                {/* Image */}
                <div
                  className="
                    mt-[9px]
                    h-[175px]
                    w-full
                    flex-shrink-0
                    overflow-hidden
                    rounded-[10px]
                  "
                >
                  <img
                    src={service.image}
                    alt={service.title}
                    className="
                      h-full
                      w-full
                      object-cover
                      object-center
                    "
                  />
                </div>

                {/* Description */}
                <div className="flex flex-1 items-center justify-center px-[2px]">
                  <p
                    className="
                      mx-auto
                      max-w-[185px]
                      text-center
                      font-host
                      text-[11px]
                      font-normal
                      leading-[1.45]
                      text-[#565656]
                    "
                  >
                    {service.description}
                  </p>
                </div>
              </article>
            ))}
          </div>
        </div>

        {/* =====================================================
            MOBILE
        ===================================================== */}
        <div className="mt-[40px] flex flex-col gap-[25px] md:hidden">
          {services.map((service, index) => (
            <div
              key={service.title}
              className="relative"
            >
              {/* Mobile dotted connector */}
              {index !== services.length - 1 && (
                <div
                  className="
                    absolute
                    left-1/2
                    top-full
                    z-0
                    h-[25px]
                    -translate-x-1/2
                    border-l
                    border-dashed
                    border-[#777777]
                  "
                />
              )}

              <article
                className="
                  relative
                  z-10
                  mx-auto
                  flex
                  w-full
                  max-w-[360px]
                  flex-col
                  rounded-[14px]
                  bg-[#E1E1E1]
                  px-[13px]
                  pb-[16px]
                  pt-[14px]
                "
              >
                {/* Mobile title */}
                <div className="flex min-h-[22px] items-center gap-[5px]">
                  <img
                    src={service.icon}
                    alt=""
                    aria-hidden="true"
                    className="
                      h-[15px]
                      w-[15px]
                      shrink-0
                      object-contain
                    "
                  />

                  <h3
                    className="
                      font-host
                      text-[14px]
                      font-medium
                      leading-none
                      text-[#262626]
                    "
                  >
                    {service.title}
                  </h3>
                </div>

                {/* Mobile image */}
                <div
                  className="
                    mt-[10px]
                    h-[220px]
                    w-full
                    overflow-hidden
                    rounded-[11px]
                  "
                >
                  <img
                    src={service.image}
                    alt={service.title}
                    className="
                      h-full
                      w-full
                      object-cover
                      object-center
                    "
                  />
                </div>

                {/* Mobile description */}
                <p
                  className="
                    mx-auto
                    mt-[12px]
                    max-w-[290px]
                    text-center
                    font-host
                    text-[12px]
                    font-normal
                    leading-[1.45]
                    text-[#565656]
                  "
                >
                  {service.description}
                </p>
              </article>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}